<template>
  <div>
    <b-container
      fluid
    >
      <b-row align-h="between">
        <b-col
          md="auto"
          cols="12"
        >
          <s-search-input
            v-model="searchTerm"
            v-s-trigger="getReports"
            :placeholder="$t('reports.search-report')"
          />
        </b-col>
        <b-col
          md="auto"
          cols="12"
        >
          <b-button
            variant="primary"
            class="mt-3 mt-md-0"
            @click="newReport"
          >
          {{ $t('reports.new-report') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row
        align-h="center"
        class="my-3"
      >
        <operation-list
          @refresh-list="getReports"
          :pagination="pagination"
          :reports="reports"
          :loading="loading"
          :sort-by.sync="sortBy"
          @page-changed="pageChanged"
          @sort-changed="sort"
        />
      </b-row>
    </b-container>
  </div>
  </template>
  <style lang="sass" scoped>
    .view-report
      &__loader-container
        min-height: 500px
  </style>

  <script>
  import OperationHistoryService from '@/domain/services/generalPanel/reports/operationHistory';
  import LoadingMixin from '@/services/loadingMixin';
  import OperationList from '@/domain/components/generalPanel/reports/operationsHistory/List';

  const nameMapper = name => ({ name });

  export default {
    name: 'ViewReport',
    components: {
      OperationList,
    },
    mixins: [
      LoadingMixin,
    ],
    data: () => ({
      searchTerm: null,
      lastSearchTerm: null,
      reports: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalRows: null,
      },
      sortBy: {
        desc: false,
      },
    }),
    computed: {
      effectiveTermToSearch() {
        return this.searchTerm && this.searchTerm.length >= 3 ? this.searchTerm : null;
      },
    },
    methods: {
      getReportsByFilter() {
        if (this.effectiveTermToSearch === this.lastSearchTerm) return;

        this.lastSearchTerm = this.effectiveTermToSearch;
        this.$set(this.pagination, 'currentPage', 1);
        this.getReports();
      },
      pageChanged(newPage) {
        this.$set(this.pagination, 'currentPage', newPage);
        this.getReports();
      },
      sort({ sortBy, sortDesc }) {
        if (!sortBy) return;
        this.sortBy.field = sortBy;
        this.sortBy.desc = sortDesc;
        this.getReports();
      },
      getReports() {
        this.startLoading();
        const { perPage, currentPage } = this.pagination;
        const payload = {
          historyName: this.searchTerm,
          pageSize: perPage,
          page: currentPage,
          sort: this.sortBy.desc ? 'desc' : 'asc',
        };

        OperationHistoryService.getTemplateList(payload)
          .then(({ data, total }) => {
            this.reports = data.map(report => ({
              ...report,
              installations: (report.installations || []).map(nameMapper),
            }));
            this.pagination.totalRows = total;
          })
          .finally(() => {
            this.endLoading();
          });
      },
      newReport() {
        this.$router.push({ name: 'reports.operations-history.new-report' });
      },
    },
    created() {
      this.getReports();
    },
  };
  </script>
